var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.loading
        ? _c("div", { staticClass: "overlay clear w-100 h-100" })
        : _vm._e(),
      _vm._v(" "),
      _c("v-client-table", {
        key: _vm.updateKey,
        ref: "clientTable",
        staticClass: "table-clients no-pagination vue-custom-table mb-0",
        class: { card: _vm.card },
        attrs: {
          data: _vm.getClients,
          columns: _vm.columns,
          options: _vm.tableOptions,
          name: _vm.tableName,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "fullName",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex" },
                    [
                      _c("div", { staticClass: "d-none d-md-block" }, [
                        _c(
                          "span",
                          {
                            class: { "new-badge": row.read === false },
                            attrs: { "data-count": _vm.getBadgeText(row) },
                          },
                          [
                            _c(
                              "profile-avatar",
                              _vm._b(
                                {
                                  staticClass: "client-avatar mr-2",
                                  attrs: {
                                    "avatar-initials": _vm.avatarInitials(row),
                                  },
                                },
                                "profile-avatar",
                                Object.assign({}, row, _vm.getInfoToShow(row)),
                                false
                              )
                            ),
                          ],
                          1
                        ),
                      ]),
                      _vm._v(" "),
                      row.latestApplicationId
                        ? _c(
                            "router-link",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: _vm.$t(
                                    "application.listing.clickToOpenLatestApp"
                                  ),
                                  expression:
                                    "$t('application.listing.clickToOpenLatestApp')",
                                },
                              ],
                              staticClass:
                                "regular my-auto text-primary text-capitalize bold client-tooltip",
                              attrs: { to: _vm.latestAppLink(row) },
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.getNameToShow(row)) +
                                  "\n        "
                              ),
                            ]
                          )
                        : _c(
                            "a",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip",
                                  value: _vm.$t(
                                    "application.listing.thisClientHasNoApplications"
                                  ),
                                  expression:
                                    "$t('application.listing.thisClientHasNoApplications')",
                                },
                              ],
                              staticClass:
                                "regular text-gray my-auto text-capitalize client-tooltip",
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(row.givenName) +
                                  " " +
                                  _vm._s(row.familyName) +
                                  "\n        "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "email",
              fn: function (ref) {
                var row = ref.row
                return [
                  row.email
                    ? _c(
                        "h4",
                        {
                          staticClass:
                            "regular text-gray m-0 d-flex align-items-center",
                        },
                        [
                          _c(
                            "i",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: _vm.getIconElements(row).tooltip,
                                  expression: "getIconElements(row).tooltip",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass:
                                "material-icons mr-1 registered-client d-none d-lg-block",
                              class: _vm.getIconElements(row).color,
                            },
                            [_vm._v(_vm._s(_vm.getIconElements(row).icon))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-break-all d-flex" }, [
                            _vm._v(
                              "\n          " + _vm._s(row.email) + "\n        "
                            ),
                          ]),
                        ]
                      )
                    : _c(
                        "h4",
                        {
                          staticClass:
                            "regular text-gray m-0 d-flex align-items-center",
                        },
                        [
                          _c(
                            "i",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.top",
                                  value: _vm.getIconElements(row).tooltip,
                                  expression: "getIconElements(row).tooltip",
                                  modifiers: { top: true },
                                },
                              ],
                              staticClass:
                                "material-icons mr-1 registered-client d-none d-lg-block",
                              class: _vm.getIconElements(row).color,
                            },
                            [_vm._v(_vm._s(_vm.getIconElements(row).icon))]
                          ),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-break-all d-none" }, [
                            _vm._v(" no email "),
                          ]),
                        ]
                      ),
                ]
              },
            },
            {
              key: "applicationStatus",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "text-light-gray" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$t("application.status." + row.applicationStatus)
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              },
            },
            {
              key: "createdAt",
              fn: function (ref) {
                var row = ref.row
                return [
                  _c("div", { staticClass: "text-light-gray" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm._f("formatDate")(_vm.getApplicationCreatedAt(row))
                        ) +
                        "\n      "
                    ),
                  ]),
                ]
              },
            },
            _vm.showActionButtons
              ? {
                  key: "actionbuttons",
                  fn: function (ref) {
                    var row = ref.row
                    return [
                      _c("div", { staticClass: "d-flex justify-content-end" }, [
                        _vm.allActionButtons
                          ? _c("div", { staticClass: "btn-group pr-2 mr-1" }, [
                              _c("div", { staticClass: "btn-group" }, [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-flat star-client",
                                    on: {
                                      click: function ($event) {
                                        return _vm.toggleStarredClient(
                                          row.username,
                                          row.agentUsername
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("i", {
                                      class: row.starred
                                        ? "fa  fa-star text-warning"
                                        : "fa fa-star-o text-grey",
                                    }),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "d-none" }, [
                                      _vm._v(
                                        _vm._s(_vm.$t("global.words.favorite"))
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "btn-group pr-2 d-none d-xl-block" },
                          [
                            !row.clientProfiles.length
                              ? _c("div", { staticClass: "dropdown" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "btn clickable action-button board-selection-container btn-white dropdown-toggle btn-sm mr-2 bold applications-client-profile-controls",
                                      attrs: {
                                        id: "dropdownMenuLinkBoard",
                                        role: "button",
                                        "data-toggle": "dropdown",
                                        "data-boundary": "scrollParent",
                                        "data-flip": "true",
                                        "aria-haspopup": "true",
                                        "aria-expanded": "false",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            _vm.$t(
                                              "application.listing.addToBoard"
                                            )
                                          ) +
                                          "\n            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "dropdown-menu",
                                      attrs: {
                                        id: "board-selection-container",
                                        "aria-labelledby":
                                          "dropdownMenuLinkBoard",
                                      },
                                    },
                                    [
                                      _c("add-to-board", {
                                        attrs: { client: row },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              : _c(
                                  "div",
                                  [
                                    _c("view-on-board", {
                                      attrs: { profiles: row.clientProfiles },
                                    }),
                                  ],
                                  1
                                ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "btn-group pl-1 pr-2 d-none d-xl-block",
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass:
                                  "btn-primary btn btn-sm view-applications",
                                on: {
                                  click: function ($event) {
                                    return _vm.showApplications(row, $event)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application.listing.viewApplications"
                                      )
                                    ) +
                                    "\n\n            "
                                ),
                                _c("i", {
                                  staticClass: "fa fa-caret-down ml-1",
                                }),
                              ]
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropleft d-flex d-xl-none" },
                          [
                            _c(
                              "a",
                              {
                                staticClass:
                                  "grey-text text-darken-4 clickable d-xl-none",
                                attrs: { "data-toggle": "dropdown" },
                              },
                              [
                                _c("i", { staticClass: "material-icons" }, [
                                  _vm._v("more_vert"),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "dropdown-menu" },
                              [
                                _c("add-to-board", {
                                  attrs: { client: row, responsive: true },
                                }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-item clickable wide px-4",
                                    on: {
                                      click: function ($event) {
                                        return _vm.showApplications(row, $event)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "button",
                                      { staticClass: "btn btn-white" },
                                      [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm.$t(
                                                "application.listing.viewApplications"
                                              )
                                            ) +
                                            "\n              "
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ]
                  },
                }
              : null,
            {
              key: "child_row",
              fn: function (props) {
                return [
                  _c("view-client-applications", {
                    attrs: {
                      "agent-username": props.row.agentUsername,
                      "client-username": props.row.username,
                      editable: _vm.allActionButtons,
                      "fully-loaded": props.row.fullyLoaded,
                      "copying-app": _vm.copyingApp,
                    },
                    on: {
                      "additional-app": function ($event) {
                        return _vm.createAdditionalApp(props.row)
                      },
                      "open-modal": function ($event) {
                        return _vm.openModal($event, props.row)
                      },
                    },
                  }),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }